import { bindable } from 'aurelia-framework';

export class JsonString {
  @bindable()
  data: object;
}
